<template>
  <div class="surface">
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    />

    <!-- <link rel="canonical" href="https://adamschwartz.co/chrome_tabs/" /> -->
    <!-- <link href="chrome_tabs/demo/css/demo.css" rel="stylesheet" /> -->
    <link href="chrome_tabs/css/chrome-tabs.css" rel="stylesheet" />
    <div class="container" :class="{ oldVersion: oldVersion }">
      <template v-if="lang == 'he'">
        <div v-if="!oldVersion" class="logo-container">
          <Icons icon="otzarlogo" width="42" height="27px"></Icons>
        </div>
        <div v-else class="logo-container" style="top: 5px">
          <Icons icon="otzarlogosmall" width="150" height="30px"></Icons>
        </div>
      </template>
      <div
        v-else
        class="exit-side"
        :style="{
          visibility: showWinClose ? 'visible' : 'hidden',
          direction: 'ltr',
        }"
      >
        <div class="toolbar-btn" @click="minimize">
          <Icons icon="minimize" width="16" height="16"></Icons>
        </div>
        <div class="toolbar-btn" @click="toggleminmax">
          <Icons :icon="iconName" stroke="black" width="16" height="16"></Icons>
        </div>
        <div class="toolbar-btn" @click="exit">
          <Icons icon="exit" width="12" height="12"></Icons>
        </div>
      </div>

      <div
        class="mock-browser"
        :style="{ visibility: showTabs ? 'visible' : 'hidden' }"
      >
        <div
          class="chrome-tabs"
          style="--tab-content-margin: 9px"
          :style="{ 'webkit-app-region': dragMode ? 'drag' : '' }"
        >
          <div
            class="plus-btn"
            style="
              position: absolute;
              margin: 0px 20px;
              right: var(--plus-right);
              height: 120%;
              width: calc(100% - var(--plus-right));
              webkit-app-region: drag;
              top: -10px;
            "
          ></div>
          <div
            style="z-index: 1"
            class="chrome-tabs-content"
            @click="setDrag"
          ></div>
          <div class="chrome-tabs-bottom-bar"></div>
        </div>
        <div class="chrome-tabs-optional-shadow-below-bottom-bar"></div>
      </div>
      <template v-if="lang != 'he'">
        <div v-if="!oldVersion" class="logo-container eng">
          <Icons icon="otzarlogo" width="42" height="27px"></Icons>
        </div>
        <div v-else class="simple-title">אוצר החכמה</div></template
      >
      <div
        v-else
        class="exit-side"
        :style="{ visibility: showWinClose ? 'visible' : 'hidden' }"
      >
        <div class="toolbar-btn" @click="minimize">
          <Icons icon="minimize" width="16" height="16"></Icons>
        </div>
        <div class="toolbar-btn" @click="toggleminmax">
          <Icons :icon="iconName" stroke="black" width="16" height="16"></Icons>
        </div>
        <div class="toolbar-btn" @click="exit">
          <Icons icon="exit" width="12" height="12"></Icons>
        </div>
      </div>
    </div>
    <div class="mock-browser-content" style="display: none">
      <div class="buttons">
        <button data-theme-toggle>Toggle dark theme</button>
        <button data-add-tab>Add new tab</button>
        <button data-add-background-tab>Add tab in the background</button>
        <button data-remove-tab>Remove active tab</button>
      </div>
    </div>
  </div>
</template>
<script src="./draggabilly.pkgd.min.js"></script>
<script>
var chromeTabs;
import Icons from "@/components/Icons/Icons.vue";

export default {
  components: { Icons },
  data() {
    return {
      tabs: [],
      dragMode: false,
      selectedTab: null,
      iconName: "max-win",
      showTabs: false,
      showWinClose: true,
      oldVersion: false,
      lang: "he",
    };
  },
  computed: {
    isEng() {
      return this.lang != "he";
    },
  },
  methods: {
    changeTabName(e) {
      //check if double click on current selected tab
      /**@type {HTMLElement}*/
      const el = e.tabEl ? e.tabEl : e.currentTarget;
      const id = el.getAttribute("data-tab-id");
      const title = el
        .querySelector(".chrome-tab-content")
        .querySelector(".chrome-tab-title").innerText;
      globalThis.OtzarTabsManager.sendEventToCurrentWebContent({
        action: "change-name",
        id,
        title,
      });
    },
    async addAndFocusTab() {
      const id = await this.addTab("");
      this.setTab(id);
    },
    changeName(e, d) {
      /**@type {HTMLElement} */
      const el = e.target;
      el.blur();
      d.title = el.innerText.replace("\n", "").trim();
      //send to db
    },
    deleteTab(id) {
      this.tabs = this.tabs.filter((a) => a.id != id);
      globalThis.OtzarTabsManager.deleteTab(id, this.tabs.length > 0);

      // if (this.tabs.length) {
      //   const t = this.tabs[0];
      //   this.setTab(t.id);
      // } else this.exit();
    },
    toggleminmax() {
      // if (this.iconName == "max-win") this.iconName = "mini-win";
      // else this.iconName = "max-win";
      globalThis.OtzarTabsManager.toggleminmax();
    },
    exit() {
      try {
        globalThis.OtzarTabsManager.exit();
      } catch {
        window.close();
      }
    },
    minimize() {
      globalThis.OtzarTabsManager.minimize();
    },
    async addTab(
      title = "אוצר החכמה",
      id = null,
      active = false,
      stick = null,
      color = null
    ) {
      if (title == "" || title == "אוצר החכמה") {
        //title = Hebcal.HDate(new Date(Date.now())).toString("h");
        const n = this.tabs.filter(
          (a) => a.title.startsWith("אוצר החכמה (") || a.title == "אוצר החכמה"
        );
        if (n.length == 0) title = "אוצר החכמה";
        else title = `אוצר החכמה (${n.length})`;
      }
      id = id == null ? Date.now() : id;
      this.tabs.push({ id, title });
      this.selectedTab = id;

      chromeTabs.addTab(
        {
          title: title,
          favicon: stick,
          id,
          color,
        },
        {
          background: !active,
        }
      );
      await globalThis.OtzarTabsManager.createNewTab(id, active, title);

      return id;
    },
    setTab(id) {
      if (!this.showTabs) return;
      this.selectedTab = id;
      globalThis.OtzarTabsManager.setFocusOnTab(id);
    },
    setDrag(e) {
      // if (e.target.className == "chrome-tabs-content") this.dragMode = true;
    },
  },
  async created() {
    // window.addEventListener("mouseup", () => {
    //   console.log("mouse up");
    //   this.dragMode = false;
    // });
    document.getElementById("splashscreen_img").style.display = "none";
    document.addEventListener("add-new-tab", () => {
      const id = this.addTab("", null, true);
    });
    document.addEventListener("SEND_MESSAGE_TO_TOOLBAR_PRELOAD", (e) => {
      const data = e.detail;
      if (data.action == "change-name") {
        document
          .querySelector('[data-tab-id="' + data.id + '"]')
          .querySelector(".chrome-tab-content")
          .querySelector(".chrome-tab-title").innerText = data.name;
      } else if (data.action == "change-color") {
        document
          .querySelector('[data-tab-id="' + data.id + '"]')
          .querySelector(".chrome-tab-content")
          .querySelector(".chrome-tab-title").style.color = data.color;
      }
    });
    document.addEventListener("tab_done_loading", (e) => {
      try {
        const lic = e.detail.lic;
        this.lang = e.detail.lang;
        if (lic.otzarLicence == 1 && lic.otzarVer > 21) {
          this.showTabs = true;
          this.oldVersion = false;
        } else {
          globalThis.OtzarTabsManager.sendEventToCurrentWebContent({
            action: "set-height",
          });

          this.oldVersion = true;
          this.showTabs = true;
          const style = document.createElement("style");

          // Make sure the style element is added to the document head
          document.head.appendChild(style);

          // Use CSSStyleSheet.insertRule() to add a new rule to the stylesheet
          style.sheet.insertRule(
            ".chrome-tabs-content .chrome-tab { display: none; }",
            style.sheet.cssRules.length
          );
          style.sheet.insertRule(
            ".plus-btn{width:calc(100% - 50px)!important;right:0px !important}",
            style.sheet.cssRules.length
          );
          style.sheet.insertRule(
            ".toolbar-plus-btn { display: none !important; }",
            style.sheet.cssRules.length
          );
        }
      } catch (ex) {
        console.log(ex);
      }
    });

    try {
      const data = await globalThis.OtzarTabsManager.getCurrentTabs();
      if (data.length && !data.find((a) => a.active)) data[0].active = 1;
      data.forEach((a) => {
        if (a.active) this.selectedTab = a.id;

        this.addTab(a.title, a.id, a.active, a.stick, a.color);
      });

      if (!data.length) {
        const id = this.addTab("", 1, true);
        setTimeout(() => {
          this.setTab(id);
        }, 10);
      }
    } catch {}
  },
  mounted() {
    this.showWinClose = globalThis.OtzarTabsManager.showWinClose();
    const ChromeTabs = require("chrome-tabs");
    var el = document.querySelector(".chrome-tabs");
    chromeTabs = new ChromeTabs();
    chromeTabs.init(el);
    el.addEventListener("tabPin", ({ detail }) => {
      const id = Number(detail.tabEl.getAttribute("data-tab-id"));
      //send to pin\unpin
      const pinned = detail.tabEl
        .querySelector(".chrome-tab-close")
        .classList.contains("hide-close");
      if (pinned) {
        detail.tabEl
          .querySelector(".chrome-tab-close")
          .classList.remove("hide-close");
        detail.tabEl.querySelector(".chrome-tab-favicon").style.stroke = "";

        detail.tabEl.querySelector(".chrome-tab-favicon").style.fill = "";
        detail.tabEl.querySelector(".chrome-tab-favicon").style.strokeWidth = 1;

        globalThis.OtzarTabsManager.pinCurrentTab(id, 2);
        // chromeTabs.tabEls = chromeTabs.tabEls.filter((a) => a != detail.tabEl);

        // chromeTabs.tabEls.forEach(el=>{

        // })
        // chromeTabs.tabEls = [detail.tabEl, ...chromeTabs.tabEls];
      } else {
        detail.tabEl
          .querySelector(".chrome-tab-close")
          .classList.add("hide-close");
        detail.tabEl.querySelector(".chrome-tab-favicon").style.stroke =
          "#c67f05";
        detail.tabEl.querySelector(".chrome-tab-favicon").style.fill =
          "#c67f05";
        detail.tabEl.querySelector(".chrome-tab-favicon").style.strokeWidth = 4;

        globalThis.OtzarTabsManager.pinCurrentTab(id, 1);
      }
      // console.log("Active tab changed", detail.tabEl);
    });
    el.addEventListener("activeTabChange", ({ detail }) => {
      const id = Number(detail.tabEl.getAttribute("data-tab-id"));
      this.setTab(id);
      // console.log("Active tab changed", detail.tabEl);
    });
    el.addEventListener("tabReorder", ({ detail }) => {
      //we need to get the new order and save to db
      let tabs = [...document.querySelectorAll("[data-tab-id]")];
      let inx = 1;
      tabs = tabs.map((a) => {
        const data = { index: inx, id: a.getAttribute("data-tab-id") };
        inx++;
        return data;
      });
      globalThis.OtzarTabsManager.sortTabs(tabs);
    });

    el.addEventListener("tabEdit", ({ detail }) => {
      // detail.tabEl.addEventListener("click", this.changeTabName);
      this.changeTabName(detail);
    });
    el.addEventListener("tabAdd", ({ detail }) => {
      //check if this is pin tab
      // const el = detail.tabEl;
      // const id = el.getAttribute("data-tab-id");
      // console.log(this.tabs);
      // detail.tabEl.querySelector(".chrome-tab-favicon").style.stroke = "blue";
      // detail.tabEl.addEventListener("dblclick", this.changeTabName);
      // console.log("Tab added", detail.tabEl)
    });
    el.addEventListener("tabRemove", ({ detail }) => {
      const id = Number(detail.tabEl.getAttribute("data-tab-id"));
      this.deleteTab(id);
      if (chromeTabs.tabEls == 0 && !this.showWinClose) {
        //trigger plus btn
        document.getElementById("plus-btn").click();
      }
      // console.log("Tab removed", detail.tabEl)
    });

    document
      .querySelector("button[data-add-tab]")
      .addEventListener("click", (_) => {
        chromeTabs.addTab({
          title: "New Tab",
          favicon: "",
        });
      });

    document
      .querySelector("button[data-add-background-tab]")
      .addEventListener("click", (_) => {
        chromeTabs.addTab(
          {
            title: "New Tab",
            favicon: "",
          },
          {
            background: true,
          }
        );
      });

    document
      .querySelector("button[data-remove-tab]")
      .addEventListener("click", (_) => {
        chromeTabs.removeTab(chromeTabs.activeTabEl);
      });

    document
      .querySelector("button[data-theme-toggle]")
      .addEventListener("click", (_) => {
        if (el.classList.contains("chrome-tabs-dark-theme")) {
          document.documentElement.classList.remove("dark-theme");
          el.classList.remove("chrome-tabs-dark-theme");
        } else {
          document.documentElement.classList.add("dark-theme");
          el.classList.add("chrome-tabs-dark-theme");
        }
      });

    window.addEventListener("keydown", (event) => {
      if (event.ctrlKey && event.key === "t") {
        chromeTabs.addTab({
          title: "New Tab",
          favicon: "",
        });
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.chrome-tabs .chrome-tab {
  width: 258px;
}
.chrome-tabs {
  padding: 6px 3px 4px 3px;
  position: relative;
  overflow: visible;
}
.chrome-tabs .chrome-tab:nth-child(1) {
  transform: translate3d(0px, 0, 0);
}

.chrome-tabs .chrome-tab:nth-child(2) {
  transform: translate3d(239px, 0, 0);
}

html.dark-theme .made-by {
  --active-background-color: #242628;
  color: #838488;
}

html.dark-theme .made-by {
  --active-background-color: #242628;
  color: #838488;
}
.surface {
  justify-content: start;
  padding: 0px;
}
.mock-browser {
  width: calc(100% - 175px);
  position: relative;
  overflow: visible;
}

.container {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  background-color: #dee1e6;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  &.oldVersion:not(.online) {
    height: 26px !important;
  }
}

.simple-title {
  padding: 8px;
  padding-bottom: 13px;
  font-family: "Noto Sans Hebrew", "Heebo", "Avenir", Helvetica, Arial,
    sans-serif;
}

.exit-side {
  display: flex;
  padding: 0px 3px;
  direction: rtl;
  align-self: center;
  position: relative;
  top: -3px;
}
.toolbar-btn {
  padding: 5px;
  display: flex;
  align-items: center;
}
.toolbar-btn:hover {
  background-color: red;
  box-shadow: 5px 5px 5px rgb(24 8 8 / 20%);
  cursor: pointer;
  fill: white;
  stroke: white;
}
.logo-container {
  justify-content: center;
  align-items: center;
  padding: 0px 10px;
  position: relative;
  right: 10px;
  &.eng {
    right: 0px !important;
    left: 10px !important;
  }
}

.container {
  direction: ltr;
}
</style>
<style>
.hide-close {
  display: none;
}
.chrome-tab-title {
  direction: rtl;
  margin: 0px !important;
  text-align: center !important;
  font-weight: 700 !important;
  color: black;
}
.chrome-tab-edit {
  cursor: pointer !important;
  display: flex;
  position: relative;
  align-items: center;
  height: 16px;
  border-color: gray;
  border-width: 1px;
  border-radius: 50%;
  color: gray;
  stroke: gray;
  width: 15px;
  margin: 0px 4px;
}
/* .chrome-tabs-content .chrome-tab {
  display: none;
} */
</style>
